import { useMemo } from 'react';

import * as hooks from './hooks';

export const useResponsibleGamingAPI = () => {
    const getDepositLimits = hooks.useGetDepositLimits();
    const getLossLimits = hooks.useGetLossLimits();
    const getForcedLossLimits = hooks.useGetForcedLossLimits();

    return useMemo(() => ({
        /**
         * Return information about current deposit limits.
         * @memberOf Playtech.API.responsibleGaming
         * @function
         * @returns {Promise<{currentLimits: object, waitingLimits: object}>}
         * @example
         * Playtech.API.server.getDepositLimits();
         */
        getDepositLimits,
        /**
         * Return information about current loss limits.
         * @memberOf Playtech.API.responsibleGaming
         * @function
         * @returns {Promise<{limits: object}>}
         * @example
         * Playtech.API.server.getLossLimits();
         */
        getLossLimits,
        /**
         * Return information about current forced loss limits.
         * @memberOf Playtech.API.responsibleGaming
         * @function
         * @returns {Promise<{limits: object}>}
         * @example
         * Playtech.API.server.getForcedLossLimits();
         */
        getForcedLossLimits
    }), [
        getForcedLossLimits,
        getDepositLimits,
        getLossLimits
    ]);
};
